import { PhysicalProductItemErrorsType } from '../../types/product-interface'

export const getPhysicalProductError = (errors: PhysicalProductItemErrorsType) =>
  !!errors['checkoutPage.physicalProductId']
